import { useEffect } from 'react'

import EventSendNotificationsFormComponent from '../../../components/events/forms/send-notifications/EventSendNotificationsFormComponent'

interface ShowsDetailPageEventSendNotificationsFormSubSectionProps {
  onSetEventTab: (tab: string) => void
  onSetNextEventTab: (tab: string) => void
  nextEventTab: string
  eventTab?: string
}

const ShowsDetailPageEventSendNotificationsFormSubSection: React.FC<
  ShowsDetailPageEventSendNotificationsFormSubSectionProps
> = (props) => {
  useEffect(() => {
    if (props.nextEventTab != '') {
      props.onSetEventTab(props.nextEventTab)
    }
  }, [props.nextEventTab])

  return <EventSendNotificationsFormComponent />
}

export default ShowsDetailPageEventSendNotificationsFormSubSection
